import React from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import GoBack from "../components/GoBack";
import { DocumentCard } from "../components/common/DocumentCard";

const Documents: React.FC = () => {
  const { t } = useTranslation();
  const { id: applicationId } = useParams<{ id: string }>();

  if (!applicationId) {
    return <p>{t("documents.error.missingApplicationId")}</p>;
  }

  return (
    <div className="mt-6">
      <GoBack />
      <h2 className="mb-2">{t("documents.title")}</h2>
      <p className="mb-2">{t("documents.subtitle")}</p>
      <p className="mb-6">{t("documents.subtitleAdditional")}</p>

      <DocumentCard
        applicationId={applicationId}
        documentType="paystub"
        titleKey="employmentVerification.paystubs.title"
        inputLabelKey="employmentVerification.paystubs.inputLabel"
        colFileNameKey="employmentVerification.paystubs.colFileName"
        colActionsKey="employmentVerification.paystubs.colActions"
        deleteLabelKey="employmentVerification.paystubs.delete"
        confirmDeleteKey="employmentVerification.paystubs.confirmDelete"
        errorFetchingKey="employmentVerification.paystubs.errorFetching"
        errorDeletingKey="employmentVerification.paystubs.errorDeleting"
        errorUploadingKey="employmentVerification.paystubs.errorUploading"
      />

      <DocumentCard
        applicationId={applicationId}
        documentType="bank-statement"
        titleKey="financial.bankStatements.title"
        inputLabelKey="financial.bankStatements.inputLabel"
        colFileNameKey="financial.bankStatements.colFileName"
        colActionsKey="financial.bankStatements.colActions"
        deleteLabelKey="financial.bankStatements.delete"
        confirmDeleteKey="financial.bankStatements.confirmDelete"
        errorFetchingKey="financial.bankStatements.errorFetching"
        errorDeletingKey="financial.bankStatements.errorDeleting"
        errorUploadingKey="financial.bankStatements.errorUploading"
      />

      <DocumentCard
        applicationId={applicationId}
        documentType="other-document"
        titleKey="documents.otherDocuments.title"
        inputLabelKey="documents.otherDocuments.inputLabel"
        colFileNameKey="documents.otherDocuments.colFileName"
        colActionsKey="documents.otherDocuments.colActions"
        deleteLabelKey="documents.otherDocuments.delete"
        confirmDeleteKey="documents.otherDocuments.confirmDelete"
        errorFetchingKey="documents.otherDocuments.errorFetching"
        errorDeletingKey="documents.otherDocuments.errorDeleting"
        errorUploadingKey="documents.otherDocuments.errorUploading"
      />
    </div>
  );
};

export default Documents;
